(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fanclub-form-control"] && !Shopify.designMode) return;
  try {
    
  /* ========== フォーム調整 ========== */
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const appEmbed = document.getElementById('app-embed');

    if (appEmbed && appEmbed.shadowRoot) {
      const shadowRoot = appEmbed.shadowRoot;

      // --- formElement の処理 ---
      const formElement = shadowRoot.querySelector('form');

      if (formElement) {
        formElement.style.margin = '5px 0 0';
        // 必要に応じて他のスタイルもここに追加
      } else {
      }

      // ----- ラベル非表示 -----
      const legendElementsToHide = Array.from(shadowRoot.querySelectorAll('legend')).filter(el => {
        return el.textContent && el.textContent.includes('hide'); // nullチェックとテキスト内容が取得できるかを確認
      });

      if (legendElementsToHide.length > 0) {
        legendElementsToHide.forEach(legend => {
          legend.style.display = 'none';
        });
      }

      // --- appRouterElement の処理 ---
      // shadowRoot のスコープ内に移動
      const appRouterElement = shadowRoot.getElementById('form-container-ref');
      if (appRouterElement) {
        // ----- ここからメディアクエリ -----
        const isPCQuery = window.matchMedia('(min-width: 769px)'); // PC判定のメディアクエリ
        if (isPCQuery.matches) { // PCサイズ(769px以上)
          appRouterElement.style.width = '100%';
        } else { // SPサイズ(769px以上)
          appRouterElement.style.width = '100vw';
        }
        // ----- ここまでメディアクエリ -----
        appRouterElement.style.padding = '0 20px';
        appRouterElement.style.boxSizing = 'border-box';
      } else {
      }

    } else {
    }
  }, 2000); // 遅延時間。アプリの初期化タイミングに合わせる必要があり、調整してください。
});

  } catch(e) { console.error(e); }
})();
})();
